import script from "./MiniCartDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniCartDrawer.vue?vue&type=script&setup=true&lang=js"

import "./MiniCartDrawer.vue?vue&type=style&index=0&id=7862b781&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7862b781"]])

export default __exports__